(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("getSomeCoolEmojis", [], factory);
	else if(typeof exports === 'object')
		exports["getSomeCoolEmojis"] = factory();
	else
		root["getSomeCoolEmojis"] = factory();
})(this, () => {
return 